import { render, staticRenderFns } from "./BackPage.vue?vue&type=template&id=1ab307dc"
import script from "./BackPage.vue?vue&type=script&lang=js"
export * from "./BackPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports